import React, { useEffect, useRef, useState } from 'react';
import './progress-bar.css';
import PropTypes from 'prop-types';
import { Paragraph } from '../paragraph';
import classNames from 'classnames';

const ProgressBar = props => {
    const { progressValue, maxValue, target } = props;

    const progressAchieved = (progressValue / maxValue) * 100;
    const targetLeftPercentage = (target / maxValue) * 100;
    const [mounted, setMounted] = useState(false);
    const [targetAchieved, setTargetAchieved] = useState(false);

    const progressRef = useRef(null);
    const progressStyles = {
        width: `${progressAchieved}%`,
    };

    useEffect(() => {
        const mountedTimeout = setTimeout(() => setMounted(true), 200);
        let targetAchievedTimeout;
        if (progressValue > target) {
            targetAchievedTimeout = setTimeout(
                () => setTargetAchieved(true),
                800,
            );
        }
        return () => {
            clearTimeout(mountedTimeout);
            clearTimeout(targetAchievedTimeout);
        };
    }, [progressValue, target]);

    const targetSpanClasses = classNames({
        'committee-results__target-span': true,
        'committee-results__target-span--achieved': targetAchieved,
    });

    return (
        <div className="progress-bar__container">
            <div
                className="committee-results__target"
                style={{
                    left: `${targetLeftPercentage}%`,
                }}
            >
                <span className={targetSpanClasses} />
                <div className="committee-results__target-paragraph">
                    <Paragraph
                        withSpacing={false}
                        colorScheme="dark"
                        withIndent={true}
                    >
                        Target
                    </Paragraph>
                </div>
            </div>
            <div role="progressbar" className="progress-bar__progress-bar">
                <span
                    className="progress-bar__inner"
                    style={mounted ? progressStyles : null}
                    ref={progressRef}
                />
            </div>
        </div>
    );
};

ProgressBar.defaultProps = {
    seconds: 3,
    maxValue: 100,
    results: false,
};

ProgressBar.propTypes = {
    seconds: PropTypes.number,
    progressValue: PropTypes.number.isRequired,
    maxValue: PropTypes.number,
    results: PropTypes.bool,
};

export { ProgressBar };
